import React from 'react';
import PropTypes from 'prop-types';
import { DndProvider as DndProviderBase } from 'react-dnd';
import Backend from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/cjs/HTML5toTouch';

export default function DndProvider({ children }) {
	return (
		<DndProviderBase backend={Backend} options={HTML5toTouch}>
			{children}
		</DndProviderBase>
	);
}

DndProvider.propTypes = {
	children: PropTypes.node.isRequired
};
